import React from 'react';
import {Button, ConfigProvider} from "antd";
import {ButtonProps} from "antd/lib/button/button";



export default function ButtonBlack({ ...props }: ButtonProps) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#000',
        },
      }}
    >
      <Button type={"primary"} {...props}>
        {props.children}
      </Button>
    </ConfigProvider>
  )
}
